module.exports = __webpack_public_path__ + "static/img/fish23.2eb51ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish23.png
// module id = jLm4
// module chunks = 0